import { Box, Button, Textarea, useToast } from '@lego/klik-ui';
import { CheckTickBold } from '@lego/klik-ui/icons';
import { useState } from 'react';
import YAML from 'yaml';
import type { DockerComposeObject } from '@/sub_pages/workspace/WorkspaceAppWizardSubPage';
import { ToastOptions } from '@/utility/ToastOptions';

type Props = {
  dockerComposeObject: DockerComposeObject;
};

export const AppWizardBoard = (props: Props) => {
  const [isClicked, setIsClicked] = useState<boolean>(false);
  const toast = useToast();

  const handleCopy = async () => {
    setIsClicked(true);

    await navigator.clipboard.writeText(YAML.stringify(props.dockerComposeObject));
    toast(ToastOptions.success('Text copied!', 'You can now paste your content!', 3000));

    setTimeout(() => setIsClicked(false), 2500);
  };

  return (
    <Box
      background="white"
      boxShadow={'md'}
      padding={6}
      position={'relative'}
      rounded={'md'}
      w={'full'}
    >
      <Button
        display={{ base: 'none', md: 'flex' }}
        isDisabled={isClicked}
        onClick={handleCopy}
        position={'absolute'}
        right={'10'}
        size={'sm'}
        top={'10'}
        w={'20'}
        zIndex={1}
      >
        {!isClicked ? 'COPY' : <CheckTickBold />}
      </Button>
      <Textarea
        height={'full'}
        position={'relative'}
        readOnly
        value={props.dockerComposeObject ? YAML.stringify(props.dockerComposeObject) : ''}
        zIndex={0}
      />
    </Box>
  );
};
